export const headerRows = [
  "Assumptions", "", 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030
]

export const bodyRows = [
  {
    title: "Rental Revenue",
    childRows: [
      {
        childTitle: "Potential Rental Revenue",
        assumptions: 2,
        assumptionsSuffix: "$/Sqft",
      },
      {
        childTitle: "Economic Vacancy",
        assumptions: 6,
        assumptionsSuffix: "%",
      },
      {
        childTitle: "Physical Vacancy",
        assumptions: 10,
        assumptionsSuffix: "%",
      },
      {
        childTitle: "Effective Gross Rental Revenue",
        assumptions: 2,
        assumptionsSuffix: "$/Sqft",
      }
    ]
  },
  {
    title: "empty",
    childRows: [
      {
        childTitle: "Total Termination Income",
        assumptions: 15000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Total Late Fees",
        assumptions: 2000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Total Parking and Others",
        assumptions: 10000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Other revenues from services provided in property",
        assumptions: 8000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Total Rental Revenues - Annual growth",
        assumptions: 2,
        assumptionsSuffix: "%/year",
      },
      {
        childTitle: "Total Rental Revenues",
        assumptions: 560000,
        assumptionsSuffix: "$",
      }
    ]
  },
  {
    title: "Rental operating expenses",
    childRows: [
      {
        childTitle: "Property Taxes",
        assumptions: 12000,
        assumptionsSuffix: "%",
      },
      {
        childTitle: "Insurance (Total)",
        assumptions: 4000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Repairs and Maintenance (Total)",
        assumptions: 8000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Property Management Fees",
        assumptions: 6000,
        assumptionsSuffix: "$/Sqft"
      },
      {
        childTitle: "Advertising (Total)",
        assumptions: 2000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Payroll and benefirst (Total)",
        assumptions: 20000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Office Supplies (Total)",
        assumptions: 1500,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Phone & Internet (Total)",
        assumptions: 1500,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Electricity",
        assumptions: 6000,
        assumptionsSuffix: "$/Sqft",
      },
      {
        childTitle: "Gas",
        assumptions: 3000,
        assumptionsSuffix: "$/Sqft",
      },
      {
        childTitle: "Other utilities",
        assumptions: 2000,
        assumptionsSuffix: "$/Sqft",
      },
      {
        childTitle: "Professional Services (Total)",
        assumptions: 3000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Misc Expenses (Total)",
        assumptions: 1000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Total Rental Operating Expenses - Annual growth",
        assumptions: 3,
        assumptionsSuffix: "%/year",
      },
      {
        childTitle: "Total Rental Operating Expenses",
        assumptions: 71070,
        assumptionsSuffix: "%",
      }
    ]
  },
  {
    title: "Power revenues",
    childRows: [
      {
        childTitle: "Trading",
        assumptions: 5000,
        assumptionsSuffix: "$/Sqft",
      },
      {
        childTitle: "Batteries (Total)",
        assumptions: 4000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "EV Charging (Total)",
        assumptions: 2000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Solar (Total)",
        assumptions: 3000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Power Assets Type.1 (Total)",
        assumptions: 1000,
        assumptionsSuffix: "$",
      },
      {
        childTitle: "Total Power Revenue",
        assumptions: 15000,
        assumptionsSuffix: "$",
      },
    ]
  },
  {
    title: "Power operating expenses",
    childRows: [
      {
        childTitle: "Fees",
        assumptions: 500,
        assumptionsSuffix: "%",
      },
      {
        childTitle: "Management Fees",
        assumptions: 2000,
        assumptionsSuffix: "%",
      },
      {
        childTitle: "Total Power Operating Expenses",
        assumptions: 2500,
        assumptionsSuffix: "$",
      }
    ]
  },
  {
    title: "Net Operating Income (NOI)",
    assumptions: 47810,
    assumptionsSuffix: "$",
  },
  {
    title: "Debt Service",
    assumptions: 30000,
    assumptionsSuffix: "$",
  },
  {
    title: "Cash Flow Before Taxes",
    assumptions: 17810,
    assumptionsSuffix: "$",
  }
]
